import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { BetaSchemaForm } from '@ant-design/pro-form';
export const SchemaForm = (props) => {
    const { formRef: _formRef, onFinish, onOk, onError, submitter, labelCol, wrapperCol, autoFocusFirstInput, grid, ...formProps } = props;
    const formRef = useRef();
    const ref = _formRef ?? formRef;
    return (_jsx(BetaSchemaForm, { layoutType: "Form", ...formProps, formRef: ref, submitter: submitter ?? false, scrollToFirstError: true, autoFocusFirstInput: autoFocusFirstInput ?? false, grid: grid ?? true, labelCol: { xs: { span: 24 }, sm: { span: 16 }, ...labelCol }, wrapperCol: { xs: { span: 24 }, sm: { span: 16 }, ...wrapperCol }, onFinish: async (formData) => {
            if (onFinish) {
                const { code, validErrors } = await onFinish(formData);
                if (code === 400 && Array.isArray(validErrors)) {
                    ref.current?.setFields(validErrors.map((ve) => {
                        return {
                            errors: [ve.message],
                            name: ve.field,
                        };
                    }));
                    onError?.({ errors: validErrors });
                }
                if (code === 200) {
                    if (onOk) {
                        onOk();
                    }
                }
            }
            return false;
        } }));
};
